export const ROLES_PATH = "/settings/roles";

export const ROLES_TABLE_CONSTANTS = {
  tableName: "role_table",
  queryKey: "roles-table",
  className: "role_table",
  exportTableName: null,
  header: "Roles",
  headerIcon: "id badge",
};
